import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Stepper, 
  Step, 
  StepLabel, 
  StepContent 
} from '@mui/material';
import { styled } from '@mui/material/styles';

// Custom styled components for the Stepper with grayscale colors
const GrayscaleStepper = styled(Stepper)(({ theme }) => ({
  '& .MuiStepConnector-line': {
    borderColor: theme.palette.grey[400]
  }
}));

const GrayscaleStepLabel = styled(StepLabel)(({ theme }) => ({
  '& .MuiStepLabel-iconContainer': {
    '& .MuiStepIcon-root': {
      color: theme.palette.grey[400],
      '&.Mui-active': {
        color: theme.palette.grey[800]
      },
      '&.Mui-completed': {
        color: theme.palette.grey[700]
      }
    }
  }
}));

const RoadmapSection = ({ title, items }) => {
  return (
    <Box sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container>
        <Typography 
          variant="h2" 
          component="h2" 
          sx={{ 
            mb: 4, 
            textAlign: 'center',
            color: 'text.secondary'
          }}
        >
          {title}
        </Typography>
        
        <Box sx={{ maxWidth: 800, mx: 'auto' }}>
          <GrayscaleStepper orientation="vertical" activeStep={1}>
            {items.map((item, index) => (
              <Step key={index} completed={item.completed}>
                <GrayscaleStepLabel>
                  <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                    {item.title}
                  </Typography>
                </GrayscaleStepLabel>
                <StepContent>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="caption" sx={{ color: 'grey.200', mb: 1 }}>
                      {item.date}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'grey.300', mt: 1 }}>
                      {item.description}
                    </Typography>
                  </Box>
                </StepContent>
              </Step>
            ))}
          </GrayscaleStepper>
        </Box>
      </Container>
    </Box>
  );
};

export default RoadmapSection;